export default {"src":"/_next/static/media/upload-file.a8688c4f.svg","height":13,"width":10,"blurWidth":0,"blurHeight":0};